module.exports = __webpack_public_path__ + "img/robo.b9ec6186.png";